import { render, staticRenderFns } from "./enteral-group-form.vue?vue&type=template&id=21bf41ec&scoped=true&lang=pug&"
import script from "./enteral-group-form.vue?vue&type=script&lang=ts&"
export * from "./enteral-group-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf41ec",
  null
  
)

export default component.exports